<template>
  <div class="page">
    <!-- 筛选 -->
    <div class="filter">
      <el-input placeholder="请输入内容" v-model="keyword" clearable prefix-icon="el-icon-search" class="sousuo"
        size="small">
      </el-input>
      <el-button type="warning" @click="handelComClick" size="small">搜索</el-button>
      <div class="filterName">状态：</div>
      <el-select v-model="takeStatu" placeholder="请选择" class="titleSelect" style="width: 100px" size="small"
        @change="handelComClick">
        <el-option v-for="item in takeStatus" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <div class="filterName" v-if="shopType == 0">门店：</div>
      <el-select v-model="shopId" placeholder="请选择" class="titleSelect" style="width: 100px" size="small"
        @change="handelComClick" v-if="shopType == 0">
        <el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-button type="warning" plain size="small" style="margin-left: 20px" @click="resetClick">重置</el-button>
    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="feedShop.name" label="门店">
        <template slot-scope="scope" v-if="scope.row.feedShop != null">
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr10'">驯养中心</span>
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr11'">小程序</span>
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr12'">金水区店</span>
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr14'">指挥中心</span>
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr17'">线上店</span>
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr18'">郑东新区店</span>
        </template>
      </el-table-column>
      <el-table-column prop="memberName" label="顾客">
      </el-table-column>
      <el-table-column prop="saleUserName" label="销售人">
        <template slot-scope="scope">
          {{ scope.row.saleUserName == null ? "--" : scope.row.saleUserName }}
        </template>
      </el-table-column>
      <el-table-column prop="breedInfo.name" label="品种">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.breedInfo.name" placement="right">
            <span>{{ scope.row.breedInfo.name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="epromNo" label="芯片编号">
      </el-table-column>
      <el-table-column prop="insideNo" label="脖圈号">
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{ scope.row.takeStatus == 0 ? "未交付" : "已交付" }}
        </template>
      </el-table-column>
      <el-table-column label="百天状态">
        <template slot-scope="scope">
          <span v-if="scope.row.hundredAssureStatus==1">未购买</span>
          <span v-if="scope.row.hundredAssureStatus==2">保障中</span>
          <span v-if="scope.row.hundredAssureStatus==3">未买过期</span>
          <span v-if="scope.row.hundredAssureStatus==4">已买过期</span>
         
        </template>
      </el-table-column>
      <el-table-column label="证书照片" prop="certificateImage">
        <template slot-scope="scope">
          <span v-if="!scope.row.certificateImage">--</span>
          <el-image v-else :src="scope.row.certificateImage" :preview-src-list="[scope.row.certificateImage]"
            style="width: 60px; height: 40px" alt="" srcset=""></el-image>
        </template>
      </el-table-column>
      <el-table-column label="宠物位置">
        <template slot-scope="scope">
          {{
        scope.row.feedShop.area_name == null
          ? "--"
          : scope.row.feedShop.area_name +
          "-" +
          scope.row.feedShop.cage_name
      }}
        </template>
      </el-table-column>
      <el-table-column label="交付时间" prop="TakeAgreementUrl">
        <template slot-scope="scope">
          {{
          scope.row.takeTime == "" || scope.row.takeTime == null
            ? ""
            : $public.FTime(scope.row.takeTime, "YYYY-MM-DD")
        }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="270">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handelDeliverClick(scope.row)"
            v-if="scope.row.takeStatus == 0">确认交付</el-button>
          <el-button type="text" size="small" @click="handelClick(scope.row)">下载确认交付表</el-button>
          <el-button type="text" size="small" v-if="scope.row.hundredAssureStatus==1"
            @click="handelPayClick(scope.row)">补缴百天</el-button>
          <el-button type="text" size="small" @click="handelNavClick(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    	<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'"  :orderId="no" @submit="submit_dialogSettlement">
			</dialogSettlement>
		</div>
    <!-- 分页 -->
    <page :total="page.total" :page="page.page" @change="changePage" style="margin-top: 22px"></page>
  </div>
</template>
<!-- feedShop area_name  cage_name-->
<script>
import axios from 'axios';
import page from "@/components/page.vue";
import { takeList, deliverPet } from "@/api/purchaseApi.js";
import dialogSettlement from "../../../components/dialog_settlement.vue"
export default {
  props: {
    shopType: {
      type: Number,
      default: 0,
    },
  },
  components: {
    page,
    dialogSettlement
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      no:'',
      dialogSettlement_state: false,
      tableData: [],
      takeStatu: 0, //状态
      takeStatus: [
        {
          value: 0,
          label: "未交付",
        },
        {
          value: 1,
          label: "已交付",
        },
      ],
      keyword: "", //列表搜索内容
      comDate: "", //日期
      shops: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "5e9412e0b2bfbc089daerr12",
          label: "金水区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr14",
          label: "指挥中心",
        },
        {
          value: "5e9412e0b2bfbc089daerr18",
          label: "郑东新区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr10",
          label: "驯养中心",
        },
      ],
      shopId: "", //门店id
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    //筛选
    handelComClick() {
      this.page.page = 1;
      this.getTableData();
    },
    // 补缴百天医疗
    handelPayClick(row) {
      console.log(row, 'row----------');
      let params = {
        memberId: row.memberId,
        order_platform: 'web',
        memberName: row.memberName,
        memberMobile: row.memberPhone,
        remark: '',
        salesMans: [
          {
            "userId": row.saleUserId,
            "userName": row.saleUserName
          }
        ],
        hundredPrice:row.differPrice,
        petInfo: {
          petId: row._id,
          insideName: row.insideName,
          insideNo: row.insideNo,
          epromNo: row.epromNo,
          avatarPic: row.avatarPic,
          salePetInfo: [],
          categoryId: row.categoryInfo._id,
          categoryName: row.categoryInfo.name,
          price: row.price
        }

      };
      let loading = this.$loading();
      this.$http.post("/api/Order/CreateBaitianMedical", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          console.log(res, 'res');
          this.no=res.data.no
          this.dialogSettlement_state = true;
        }
      });
    },
    	// 结算
		submit_dialogSettlement(a) {
			this.dialogSettlement_state = false;
			if (a == 'cancel') {
				console.log(a)
			} else if (a == 'fail') {
				this.$message({
					message: '结算失败',
					type: 'error'
				});
			} else if (a == 'success') {
				this.$message({
					message: '结算成功',
					type: 'success'
				});
        this.getTableData();
				this.$store.dispatch("mendian/getUserInfo", this.userInfo._id)
			}
			this.$store.commit('living/set_type', 'list')
			this.$store.commit('living/set_refresh')

		},
    // 下载交付确认表
    handelClick(row) {
      console.log(row, 'row');
      axios.get(process.env.VUE_APP_Url_8000 + '/api/product/pet/download/take/confirm/table', {
        params: {
          petId: row._id
        },
        responseType: 'blob'
      }).then(response => {
        console.log(response)
        var href = window.URL.createObjectURL(response.data); //创建下载的链接
        var downloadElement = document.createElement('a');
        downloadElement.href = href;
        downloadElement.download = '交付确认表.docx';
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(err => {
        console.log(err)
      })
    },
    //确认交付
    handelDeliverClick(row) {
      // console.log(row)
      this.$confirm("是否确认交付该宠物？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            petId: row._id,
            remark: "",
          };
          deliverPet(params).then((res) => {
            if (res.code == 0) {
              console.log(res);
              this.$message({
                type: "success",
                message: "已交付",
              });
              this.getTableData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //跳转
    handelNavClick(row) {
      let query = {
        id: row._id,
      };
      this.$router.push({
        path: "detail",
        query,
      });
    },
    //重置数据
    resetClick() {
      this.page.page = 1;
      this.keyword = "";

      this.takeStatu = 0;
      this.comDate = "";
      if (this.shopType == 0) {
        this.shopId = "";
      }
      this.getTableData();
    },
    //获取数据
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        takeStatus: this.takeStatu,
      };
      if (this.shopType == 0) {
        params.shopId = this.shopId;
      } else {
        params.shopId = this.$store.state.shopId;
      }
      takeList(params).then((res) => {
        if (res.code == 0) {
          console.log("待交付列表", res);
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 762px;
  background: #fff;
  margin-top: 12px;
  font-size: 14px;

  .filter {
    height: 58px;
    display: flex;
    align-items: center;

    .sousuo {
      width: 153px;
      margin-right: 4px;
      margin-left: 16px;
    }

    .filterName {
      margin-left: 20px;
      margin-right: 4px;
    }
  }
}
</style>
